import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import React, { useEffect, useMemo, useState } from 'react';
import { tripBoardColumns, tripBoardRows } from './TripBoardItems';
import { useGetAccessorialCodesQuery } from '../../../features/Dispatch/DispatchSlice';
import { useAddDriverToOrderMutation } from '../../../features/Dispatch/TripDispatchSlice';
import { toast } from 'react-toastify';

const DynamicOrdersTable = (props) => {
    const [orders, setOrders] = useState([]);
    const { data: accessorialCodes } = useGetAccessorialCodesQuery();
    const { nowLater, boardType, selectedTrip } = props
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [addDriverToOrder] = useAddDriverToOrderMutation();

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    useEffect(() => {
        if (props.tripOrdersClassification && props.tripOrdersClassification.data) {
            if (props.tripOrdersClassification.error && props.tripOrdersClassification.error.status === 400) {
                setFilteredOrders([])
            }
            else if (props.classificationRadio === 1) {
                setFilteredOrders(props.tripOrdersClassification.data.data.outboundOrders)
            }
            else if (props.classificationRadio === 2) {
                setFilteredOrders(props.tripOrdersClassification.data.data.inboundOrders)
            }
            else if (props.classificationRadio === 3) {
                setFilteredOrders(props.tripOrdersClassification.data.data.tripAndReturnOrders)
            }
            else {
                setFilteredOrders([])
            }
        }
        else {
            setFilteredOrders([])
        }
    }, [props.tripOrdersClassification, props.classificationRadio, props.selectedTrip])

    const classificationMap = {
        1: 'Outbound Orders',
        2: 'Inbound Orders',
        3: 'Trip & Return Orders',
        4: 'Driver Routing'
    }

    const fieldMap = {
        'PDriv': 'pickup',
        'DDrive': 'delivery',
        'lineHauler': 'lineHauler',
        'pxDock': 'pickupxdock',
        'dxDock': 'deliveryxdock',
    }

    const assignDriver = async (cell) => {
        const orderNumber = cell.row?.OrderNumber;
        const orderID = cell.row?.id;
        if (cell.field === "PDriv" || cell.field === "DDrive" || cell.field === "lineHauler" || cell.field === "pxDock" || cell.field === "dxDock") {
            if (!props.selectedDriver) {
                toast.error('Please select a driver first', { position: 'top-center' }
                );
                return;
            }
            if (!props.selectedDriverForTransfer && props.driverType === 'Interdivision') {
                toast.error('Please set up a company profile for this division', { position: 'top-center' });
                return;
            }
            if (!props.selectedDriverForTransfer) {
                const body = {
                    orderId: orderID,
                    orderNumber: orderNumber,
                    driverNumber: props.selectedDriver.driverNumber,
                    driverType: props.driverType,
                    driverAssignmentType: fieldMap[cell.field],
                    divisionId: props.divisionIdRef.current
                }
                const response = await addDriverToOrder(body);
                if (response.data.statusCode === 200) {
                    toast.success(response.data.message, { position: 'top-center' });
                    if (props.boardType === "OPEN_BOARD") {
                        props.getAllOpenTripOrders(props.divisionIdRef.current);
                    }
                    else {
                        props.refetchTripOrders();
                        props.getTripOrdersClassification({ tripStatus: statusMap[props.selectedTrip?.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionIdRef.current })
                    }
                }
                else {
                    toast.error(response.data.message, { position: 'top-center' });
                }
                return;
            }
            props.setOrderNumber(orderNumber);
            props.setOrderID(orderID);
            if (cell.field === "PDriv") {
                props.setShowPickupTransfer(true);
            }
            else if (cell.field === "DDrive") {
                props.setShowDeliveryTransfer(true);
            }
        }
        else if (cell.field === 'tripNo') {
            props.addOrderToTrip(cell.row.OrderNumber);
        }
        props.setOrderNumber(orderNumber);
        props.setOrderID(orderID);
    }

    useEffect(() => {
        if (props.ordersResult && props.ordersResult.data?.data) {
            setOrders(props.ordersResult.data.data)
        }
        else {
            setOrders([])
        }
    }, [props.ordersResult])
    const nowOrders = tripBoardRows(orders)?.filter((order) => {
        const bookingTime = new Date(order?.readyTime);
        const currentTime = new Date();
        const timeDifference = bookingTime - currentTime;
        const hoursDifference = timeDifference / (1000 * 60 * 60);
        return hoursDifference <= 4;
    });

    const laterOrders = tripBoardRows(orders)?.filter((order) => {
        const bookingTime = new Date(order?.readyTime);
        const currentTime = new Date();
        const timeDifference = bookingTime - currentTime;
        const hoursDifference = timeDifference / (1000 * 60 * 60);
        return hoursDifference > 4;
    });
    const rows = useMemo(() => {
        if (!props.divisionIdRef.current) {
            return [];
        }
        if (boardType === "TRIP_BOARD") {
            return tripBoardRows(filteredOrders);
        }
        return nowLater === "now" ? nowOrders : laterOrders;
    }, [props.divisionIdRef, boardType, nowLater, nowOrders, laterOrders, filteredOrders]);

    return (
        <div className="user-role-table" style={{ height: "600px" }}>
            <h6>{boardType === "OPEN_BOARD" ? "Open Orders" : `Trip Orders ${selectedTrip?.tripNo} (${classificationMap[props.classificationRadio]})`}</h6>
            <DataGrid
                rows={rows}
                columns={tripBoardColumns(props, { accessorialCodes, orderClassification: classificationMap[props.classificationRadio] })}
                pageSize={10}
                rowsPerPageOptions={[1]}
                components={{ Toolbar: GridToolbar }}
                onCellClick={(cell) => { assignDriver(cell) }}
            />
        </div>
    )
}

export default DynamicOrdersTable
